import { Mark } from "@tiptap/core";

// This file defines a Tiptap extension for setting font family in a rich text editor.
export const FontFamily = Mark.create({
  name: "fontFamily",

  // This extension is used to style text with different font families.
  // It can be applied to text nodes in the editor.
  addOptions() {
    return {
      types: ["textStyle"],
    };
  },

  // This method defines the attributes that can be set for this mark.
  // In this case, it allows setting a font family.
  addAttributes() {
    return {
      fontFamily: {
        default: null,
        parseHTML: (element) => element.style.fontFamily || null,
        renderHTML: (attributes) => {
          if (!attributes.fontFamily) return {};
          return { style: `font-family: ${attributes.fontFamily}` };
        },
      },
    };
  },

  // This method defines how the mark should be parsed from HTML.
  // It looks for the 'style' attribute to extract the font family.
  parseHTML() {
    return [
      {
        style: "font-family",
      },
    ];
  },

  // This method defines how the mark should be rendered in HTML.
  // It creates a 'span' element with the appropriate styles.
  renderHTML({ HTMLAttributes }) {
    return ["span", HTMLAttributes, 0];
  },

  // This method adds commands to the editor for setting and unsetting the font family.
  // It allows users to change the font family of selected text.
  addCommands() {
    return {
      setFontFamily:
        (fontFamily) =>
        ({ chain }) => {
          return chain().setMark(this.name, { fontFamily }).run();
        },
      unsetFontFamily:
        () =>
        ({ chain }) => {
          return chain().unsetMark(this.name).run();
        },
    };
  },
});
